/* eslint-disable no-useless-catch */
import { uploadService } from './services';
import { removeUserAgent, updateUserAgent } from './services/entity';

const pathname = '/cdn';

export const UploadApi = {
  uploadSingleFile: async (id: string, type: string, file: any) => {
    const formData = new FormData();

    if (file.length > 0) {
      file.forEach((item, index) => formData.append(`files${index}`, item));
    } else {
      formData.append('files', file);
    }

    // * Xóa đi user agent gì upload server không có header này
    const header: any = removeUserAgent();

    try {
      const response = await uploadService.post(
        `${pathname}?id=${id}&type=${type}`,
        formData
      );
      return response;
    } catch (error) {
      throw error;
    } finally {
      // * Set lại user agent sau khi upload
      updateUserAgent(header);
    }
  },
};
